import { Head, useForm } from '@inertiajs/react'
import { FormEvent } from 'react'
import { HiArrowCircleRight } from 'react-icons/hi'
import AuthLayout from '../../components/AuthLayout'

export default function Login() {
  const form = useForm({ email: '' })

  const submit = (e: FormEvent) => {
    e.preventDefault()
    form.post('/login')
  }

  return (
    <>
      <Head title="Log in" />
      <AuthLayout>
        <h1 className="font-display text-2xl font-medium tracking-tight text-midnight-green">
          Login to your account
        </h1>

        <form onSubmit={submit} className="mt-5 space-y-5">
          <div className="space-y-1">
            <label
              htmlFor="email"
              className="block font-display text-base font-medium text-gray-700"
            >
              Email
            </label>
            <input
              id="email"
              type="email"
              autoFocus
              required
              value={form.data.email}
              onChange={(e) => form.setData('email', e.target.value)}
              placeholder="you@example.com"
              className="block w-full rounded-md border border-gray-300 bg-white px-[13px] py-[9px] text-base text-gray-900 placeholder-gray-400 shadow-sm focus:border-midnight-green focus:outline-none focus:ring-1 focus:ring-midnight-green"
            />
            {form.errors.email && (
              <p className="pt-1 text-sm text-rose-600">{form.errors.email}</p>
            )}
          </div>

          <button
            type="submit"
            disabled={form.processing}
            className="flex w-full items-center justify-center gap-2 rounded-md bg-ink px-8 py-4 font-display text-base font-medium text-white transition hover:bg-midnight-green disabled:opacity-50"
          >
            {form.processing ? 'Sending…' : 'Login'}
            <HiArrowCircleRight className="h-5 w-5" aria-hidden="true" />
          </button>
        </form>
      </AuthLayout>
    </>
  )
}
